class FooterModel {
  constructor(components = []) {
    this.sections = components;
  }
}

export default FooterModel;
